import { useState } from "react"
import React from "react";
import BBDatePicker from "./BBDatePicker";
import PastDatePicker from "./PastDatePicker";
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import "./Regex"
import { validEmail, validFzgId } from "./Regex";
import { useForm, Controller } from "react-hook-form";
import { useEffect } from "react";
import { format } from 'date-fns';


export function Kundendaten(props) {
  const {
    handleSubmit,
    register,
    watch,
    setValue,

    formState: { errors },
  } = useForm();

  useEffect(() => {
    const autofillData = {
      vorname: props.state.vorname,
      nachname: props.state.nachname,
      adresse: props.state.adresse,
      tel: props.state.tel,
      email: props.state.email,
      datenspeicherung: props.state.einwilligung
    };

    Object.keys(autofillData).forEach(field => {
      if (autofillData[field] !== register(field).value) {
        setValue(field, autofillData[field]);
      }
    });
  }, [props.state]);

  const onSubmit = (data) => {
    console.log("submitting...Kundendaten");
    console.log("DATA:", data);

    const baseUrl = process.env.REACT_APP_API_URL;

    const requestBody = {
      ...props.finalFormData,
      ...data
    };

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody)
    };

    fetch(`${baseUrl}/items/buchung`, requestOptions)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        props.setPage(10);
      });
  }

  console.log(errors);
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <h2 className="font-size400 align-left bluetext">Kontaktdaten eingeben</h2>
      <div className="rowToColumn2">

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-vorname" className="form-label required formCustomText">Vorname</label>
          <input type="text"
            {...register("vorname", { required: true })}
            className="form-control" id="form-vorname" aria-describedby="firstname" value={props.state.vorname} onChange={(e) => { props.setState({ ...props.state, vorname: e.target.value }) }} aria-invalid={errors.vorname ? "true" : "false"} />
          {errors.vorname?.type === 'required' && <p role="alert" className="font-size100 alert alert-danger">Verpflichtendes Feld</p>}
        </div>

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-nachname" className="form-label required formCustomText">Nachname</label>
          <input type="text"
            {...register("nachname", { required: true })}
            className="form-control" id="form-nachname" aria-describedby="lastname" value={props.state.nachname}
            onChange={(e) => {
              props.setState({ ...props.state, nachname: e.target.value })
            }}
          />
          {errors.nachname?.type === 'required' && <p role="alert" className="font-size100 alert alert-danger">Verpflichtendes Feld</p>}
        </div>

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-adresse" className="form-label required formCustomText">Anschrift</label>
          <input type="text"
            {...register("adresse", { required: true })}
            className="form-control" id="form-adresse" aria-label="adresse" aria-describedby="basic-addon1" value={props.state.adresse}
            onChange={(e) => { console.log(e.target.value); props.setState({ ...props.state, adresse: e.target.value }) }}
          />
          {errors.adresse?.type === 'required' && <p role="alert" className="font-size100 alert alert-danger">Verpflichtendes Feld</p>}
        </div>

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-tel" className="form-label required formCustomText">Mobilnummer</label>
          <input type="tel"
            {...register("tel", { required: "Verpflichtendes Feld", minLength: { value: 10, message: "Muss mindestens 10 Felder lang sein" } })}
            className="form-control" id="form-tel" aria-label="telefon" aria-describedby="basic-addon1" value={props.state.tel}
            onChange={(e) => { props.setState({ ...props.state, tel: e.target.value }) }} />
          {errors.tel && <p role="alert" className="font-size100 alert alert-danger">{errors.tel.message}</p>}
        </div>

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-email" className="form-label required formCustomText">E-Mail Adresse</label>
          <input type="email"
            {...register("email", { required: "Dieses Feld ist verpflichtend", pattern: { value: /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$/, message: "Muss eine gültige Email Adresse sein!" } })}
            className="form-control" id="form-email" aria-label="email" aria-describedby="basic-addon1" value={props.state.email}
            onChange={(e) => { props.setState({ ...props.state, email: e.target.value }) }} />
          {errors.email && <p role="alert" className="font-size100 alert alert-danger">{errors.email.message}</p>}
        </div>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          {...register("datenspeicherung", { required: true })}
          id="datenspeicherung"
          name="datenspeicherung"
          value="datenspeicherung"
          checked={props.state.einwilligung}
          className="form-check-input"
          onChange={(e) => { props.setState({ ...props.state, einwilligung: e.target.checked }) }} />
        <label htmlFor="datenspeicherung" className="form-label required">Mit der Buchung gebe ich Boxer-Bikes meine ausdrückliche Einwilligung, persönliche Daten für die Terminvereinbarung speichern und verarbeiten zu dürfen, und mich gegebenenfalls über die angegebenen Kontaktdaten kontaktieren zu dürfen.</label>
      </div>
      {errors.datenspeicherung?.type === 'required' && <p role="alert" className="font-size100 alert alert-danger">Verpflichtendes Feld</p>}
      <div className="button-container">
        <button type="submit" className="btn font-size175 submit-form-btn">Verbindlich buchen</button>
      </div>

    </form>)
}

export function Filialenwahl(props) {
  const {
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("submitting...Filialenwahl");
    console.log("DATA:", data);
    props.setFinalFormData({ ...(props.finalFormData), ...data });
    props.setPage(props.pageNum + 1);
  };

  const formData = props.formData;
  const setFormData = props.setFormData;
  const mOptions = props.standorte;

  const handleStandortChange = (index) => {
    setFormData({
      ...formData,
      name: mOptions[index].name,
      anzeigename: mOptions[index].anzeigename,
      default_arbeitseinh: mOptions[index].default_arbeitseinh,
    });
    props.resetDate();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <div className="mb-3">
        <h2 className="font-size400 align-left bluetext">Standort wählen</h2>
        <div className="form-padding-5">
          <p>Service-Partner in deiner Nähe</p>
          <div className="rowToColumn2">
            <div className="rowToColumn-item opensans-light flexb-40 font-size150">
              <p>
                Unsere Motorrad-Fachbetriebe werden sorgfältigst ausgewählt und besonders geschult.
                Auch werden es immer mehr.
              </p>
            </div>
            <div className="rowToColumn-item flexb-40">
              {mOptions.map((m_option, index) => (
                <div className="form-check font-size150" key={index}>
                  <input
                    type="radio"
                    className="form-check-input"
                    key={index}
                    value={m_option.name}
                    checked={props.formData.name === m_option.name}
                    {...register("standort", { required: "Bitte einen Standort auswählen" })}
                    onChange={() => handleStandortChange(index)}
                    id={"formcheck" + m_option.name}
                  />
                  <label className="form-check-label" htmlFor={"formcheck" + m_option.name}>
                    {m_option.anzeigename} <br></br>
                    {m_option.strasse},<br />
                    {m_option.postleitzahl} {m_option.stadt}
                  </label>
                </div>
              ))}
              {errors.standort && (
                <p role="alert" className="font-size100 alert alert-danger">
                  {errors.standort.message}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="button-container">
        <button type="submit" className="btn font-size175 submit-form-btn">
          Weiter
        </button>
      </div>
    </form>
  );
}






// export function ServiceDetails(props) {
//   const {
//     control,
//     handleSubmit,
//     register,
//     watch,
//     formState: { errors },
//   } = useForm();

//   const onSubmit = (data) => {
//     console.log("submitting...ServiceDetails");
//     console.log("DATA:", data);
//     props.setFinalFormData({ ...(props.finalFormData), ...data });
//     console.log("FormData", props.finalFormData);
//     props.setPage(props.pageNum + 1);
//   }
//   console.log(errors);

//   const formData = props.formData;
//   const setFormData = props.setFormData;
//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <div className="rowToColumn">
//         <div className="mb-3 rowToColumn-item flexb-40">
//           <label htmlFor="form-fzg-id" className="form-label required" id="fzg-id">Fahrzeug-ID (die letzten 7 Stellen im Zulassungsschein)</label>
//           <input type="number" {...register("fzg_id", { required: "Dieses Feld ist verpflichtend", minLength: { value: 7, message: "Die ID muss genau 7 Stellen haben" }, maxLength: { value: 7, message: "Die ID darf nicht mehr als 7 Stellen haben" } })} className="form-control" pattern="[0-9]{7}" id="form-fzg-id"
//             aria-describedby="fzg-id" aria-invalid={errors.fzg_id ? "true" : "false"}
//             value={formData.fzg_id}
//             onChange={(e) => { setFormData({ ...formData, fzg_id: e.target.value }) }} />
//           {errors.fzg_id && <p role="alert" className="font-size100 alert alert-danger">{errors.fzg_id.message}</p>}
//         </div>
//         <div className="mb-3 rowToColumn-item flexb-40">
//           <label htmlFor="form-erstzulassung" className="form-label required" id="Erstzulassung">Erstzulassung</label>
//           <Controller
//             control={control}
//             name='erstzulassung'
//             rules={{ required: "Dieses Feld ist verpflichtend" }}
//             render={({ field: { onChange, onBlur, value, name, ref } }) => (
//               <PastDatePicker
//                 onChange={onChange}
//                 selected={value}
//                 formData={formData}
//                 setFormData={setFormData}
//                 id="form-erstzulassung"
//                 dataName="erstzulassung"
//               />
//             )}
//           />
//           {errors.erstzulassung && <p role="alert" className="font-size100 alert alert-danger">{errors.erstzulassung.message}</p>}
//         </div>

//         <div className="mb-3 rowToColumn-item flexb-40">
//           <label htmlFor="form-letzter-servicetermin" className="form-label" id="letzter-servicermin">Datum des letzten Servicetermins</label>
//           <Controller
//             control={control}
//             name='letzter_servicetermin'
//             render={({ field: { onChange, onBlur, value, name, ref } }) => (
//               <PastDatePicker
//                 onChange={onChange}
//                 selected={value}
//                 formData={formData}
//                 setFormData={setFormData}
//                 dataName="letzter_servicetermin"
//                 id="form-letzter-servicetermin"
//               />
//             )}
//           />
//           {errors.date_input && <p role="alert" className="font-size100 alert alert-danger">{errors.date_input.message}</p>}
//         </div>
//         <div className="mb-3 rowToColumn-item flexb-40">
//           <label htmlFor="form-letzter-servicetermin-km" className="form-label" id="letzterServicetermin">Kilometerstand bei deinem letzten Termin</label>
//           <input type="number" {...register("letzter_servicetermin_km", { min: { message: "Muss eine positive Zahl sein", value: 0 } })} className="form-control" id="form-letzter-servicetermin-km" aria-describedby="letzterServicetermin" value={formData.letzter_km_stand} onChange={(e) => { setFormData({ ...formData, letzter_km_stand: e.target.value }) }} />
//           {errors.letzter_servicetermin_km && <p role="alert" className="font-size100 alert alert-danger">{errors.letzter_servicetermin_km.message}</p>}
//         </div>
//         <div className="mb-3 rowToColumn-item flexb-40">
//           <label htmlFor="form-km-stand" className="form-label required" id="Kilometerstand">Aktueller Kilometerstand</label>
//           <input type="number" {...register("km_stand", { required: "Dieses Feld ist verpflichtend" })} className="form-control" id="form-km-stand" aria-invalid={errors.km_stand ? "true" : "false"} aria-describedby="Kilometerstand" value={formData.km_stand} onChange={(e) => { setFormData({ ...formData, km_stand: e.target.value }) }} />
//           {errors.km_stand && <p role="alert" className="font-size100 alert alert-danger">{errors.km_stand.message}</p>}
//         </div>
//       </div>
//       <div className="button-container">
//         <button type="submit" className="btn font-size175 submit-form-btn">Weiter</button>
//       </div>
//     </form>
//   )
// }

export function ServicePicker(props) {
  const state = props.state;
  const setState = props.setState;
  const options = props.options;
  const fzgState = props.fzgState;
  const formData = props.formData;
  const setFormData = props.setFormData;

  useEffect(() => {
    // Фильтруем варианты здесь
    const filteredOptions = getCustomServices(fzgState, options);
    // Устанавливаем отфильтрованные варианты в state
    setState(filteredOptions[0]); // Предполагая, что filteredOptions всегда содержит хотя бы один элемент
  }, [fzgState, options]);

  const {
    control,
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("submitting...ServicePicker");
    console.log("DATA:", data)
    props.setFinalFormData({ ...(props.finalFormData), ...data });
    props.setPage(props.pageNum + 1);
  }


  const jahresServiceMinDays = 200;
  const km_kulanz = 3000;
  const newOptions = getCustomServices(fzgState, options);

  function getCustomServices(fzgState, options) {
    console.log(fzgState);
    let today = new Date();

    if (typeof options !== 'undefined') {
      const availableOptions = [];
      const fzgDaten = fzgState;
      if (typeof fzgDaten !== 'undefined') {
        if (typeof fzgDaten.letzter_servicetermin !== 'undefined' && fzgDaten.letzter_servicetermin) {
          const erstzulassung = fzgDaten.letzter_servicetermin;
          const timeDifferenceInDays = (today.getTime() - erstzulassung.getTime()) / (1000 * 60 * 60 * 24);
          console.log(timeDifferenceInDays);
          if (timeDifferenceInDays >= jahresServiceMinDays) {
            const Jahresservice = options.find(x => x.name === "Jahresservice");
            if (Jahresservice) {
              availableOptions.push(Jahresservice);
            }
          }
        } else {
          const Jahresservice = options.find(x => x.name === "Jahresservice");
          if (Jahresservice) {
            availableOptions.push(Jahresservice);
          }
        }
        if (typeof fzgDaten.km_stand !== 'undefined' && fzgDaten.km_stand) {
          const km_stand = fzgDaten.km_stand;
          for (let option of options) {
            if (option.km_limit) {
              let upperBorder = option.km_limit + km_kulanz;
              let lowerBorder = option.km_limit - km_kulanz;
              if ((lowerBorder <= km_stand && upperBorder >= km_stand) || ((option.km_limit === 40000) && (km_stand > option.km_limit))) {
                availableOptions.push(option);
              }
            }
          }
        } else {
          for (let option of options) {
            if (option.km_limit) {
              availableOptions.push(option);
            }
          }
        }
        return availableOptions;
      } else {
        return options;
      }
    } else {
      return [];
    }
  }

  return (

    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <h2 className="font-size400 align-left bluetext">Service wählen</h2>

      <div className="rowToColumn2">

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-fzg-id" className="form-label required formCustomText" id="fzg-id">Fahrzeug-ID <span style={{ fontSize: '13px', fontWeight: 'bold' }}>(die letzten 7 Stellen im Zulassungsschein)</span></label>
          <div class="react-datepicker__input-container">
            <input type="number" {...register("fzg_id", { required: "Dieses Feld ist verpflichtend", minLength: { value: 7, message: "Die ID muss genau 7 Stellen haben" }, maxLength: { value: 7, message: "Die ID darf nicht mehr als 7 Stellen haben" } })} className="form-control" pattern="[0-9]{7}" id="form-fzg-id"
              aria-describedby="fzg-id" aria-invalid={errors.fzg_id ? "true" : "false"}
              value={formData.fzg_id}
              onChange={(e) => { setFormData({ ...formData, fzg_id: e.target.value }) }} />
          </div>

          {errors.fzg_id && !formData.fzg_id && (
            <p role="alert" className="font-size100 alert alert-danger">Dieses Feld ist verpflichtend</p>
          )}
          {errors.fzg_id && formData.fzg_id.length !== 7 && (
            <p role="alert" className="font-size100 alert alert-danger">Die ID muss genau 7 Stellen haben</p>
          )}
        </div>
        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-erstzulassung" className="form-label required formCustomText" id="Erstzulassung">Erstzulassung</label>
          <Controller
            control={control}
            name='erstzulassung'
            rules={{ required: "Dieses Feld ist verpflichtend" }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => {
              console.log("Value:", value); // Выводим значение value в консоль
              console.log("Errors:", errors); // Выводим ошибки в консоль
              return (
                <PastDatePicker
                  onChange={onChange}
                  selected={value}
                  formData={formData}
                  setFormData={setFormData}
                  id="form-erstzulassung"
                  dataName="erstzulassung"
                />
              );
            }}
          />
          {errors.erstzulassung && <p role="alert" className="font-size100 alert alert-danger">{errors.erstzulassung.message}</p>}
        </div>

        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-letzter-servicetermin" className="form-label formCustomText" id="letzter-servicermin">Datum des letzten Servicetermins</label>
          <Controller
            control={control}
            name='letzter_servicetermin'
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <PastDatePicker
                onChange={onChange}
                selected={value}
                formData={formData}
                setFormData={setFormData}
                dataName="letzter_servicetermin"
                id="form-letzter-servicetermin"
              />
            )}
          />
          {errors.date_input && <p role="alert" className="font-size100 alert alert-danger">{errors.date_input.message}</p>}
        </div>
        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-letzter-servicetermin-km" className="form-label formCustomText" id="letzterServicetermin">Kilometerstand bei deinem letzten Termin</label>
          <div class="react-datepicker__input-container">
            <input type="number" {...register("letzter_servicetermin_km", { min: { message: "Muss eine positive Zahl sein", value: 0 } })} className="form-control" id="form-letzter-servicetermin-km" aria-describedby="letzterServicetermin" value={formData.letzter_km_stand} onChange={(e) => { setFormData({ ...formData, letzter_km_stand: e.target.value }) }} />
          </div>
          {errors.letzter_servicetermin_km && <p role="alert" className="font-size100 alert alert-danger">{errors.letzter_servicetermin_km.message}</p>}
        </div>
        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-km-stand" className="form-label required formCustomText" id="Kilometerstand">Aktueller Kilometerstand</label>
          <div class="react-datepicker__input-container">
            <input type="number" {...register("km_stand", { required: "Dieses Feld ist verpflichtend" })} className="form-control" id="form-km-stand" aria-invalid={errors.km_stand ? "true" : "false"} aria-describedby="Kilometerstand" value={formData.km_stand} onChange={(e) => { setFormData({ ...formData, km_stand: e.target.value }) }} />
          </div>
          {errors.km_stand && formData.km_stand === "" && (
            <p role="alert" className="font-size100 alert alert-danger">{errors.km_stand.message}</p>
          )}
        </div>
        <div className="mb-3 rowToColumn-item flexb-40">
          <label htmlFor="form-service" className="form-label required formCustomText">Serviceleistung</label>
          <div class="react-datepicker__input-container">
            <select
              {...register("service", { required: "Dieses Feld ist verpflichtend!", min: { value: 0, message: "Bitte eine Serviceart auswählen" } })}
              id="form-service"
              className="form-select"
              aria-label="Default select example"
              required
              value={state.id}
              onChange={(e) => {
                let sel = options.find(x => ("" + x.id) === e.target.value);
                if (sel) {
                  setState({
                    ...state,
                    id: sel.id,
                    name: sel.name,
                    arbeitseinheiten: sel.arbeitseinheiten,
                    preis: sel.preis
                  });
                }
              }}
            >
              {newOptions.map(function (m_option) {
                return <option key={m_option.id} value={m_option.id}> {m_option.name} </option>
              })}
            </select>
          </div>


          {errors.service && formData.service === 0 && (
            <p role="alert" className="font-size100 alert alert-danger">{errors.service.message}</p>
          )}        </div>
      </div>
      <div className="button-container">
        <button type="submit" className="btn font-size175 submit-form-btn">Weiter</button>
      </div>
    </form>
  )
}

export function FormDatePicker(props) {
  const {
    control,
    handleSubmit,
    register,
    watch,
    formState: { errors }, } = useForm();


  const standortState = props.standortState;
  const serviceState = props.serviceState;

  const onSubmit = (data) => {
    console.log("submitting...Datepicker");
    console.log("DATA:", data)
    props.setFinalFormData({ ...(props.finalFormData), ...data });
    props.setPage(props.pageNum + 1);
  }


  return (<form onSubmit={handleSubmit(onSubmit)} noValidate>
    <h2 className="font-size400 align-left bluetext">Wähle deinen Termin</h2>
    <div className="form-padding-5 noPad">
      
      <div className="rowToColumn2">
        <div className="rowToColumn-item opensans-light flexb-40 font-size150">
        <p><b>Übergabe bis 8:30</b></p>
          <p>Nach Absprache kannst du uns dein Motorrad auch schon in den Tagen vorher übergeben.</p>
        </div>
        <div className="rowToColumn-item flexb-40 calend">
          <label htmlFor="form-datum" className="form-label required" id="datum">Dein gewünschtes Datum</label>

          <Controller
            control={control}
            name="datum"
            rules={{ required: "Dieses Feld ist verpflichtend" }}
            render={({ field: { onChange, onBlur, value, name, ref } }) => (
              <BBDatePicker id="form-datum"

                valueName="selected"
                state={props.formData}
                setState={props.setFormData}
                standortState={standortState}
                serviceState={serviceState}
                onChange={onChange}
                selected={value}
              >
              </BBDatePicker>
            )}
          />
          {errors.datum && <p role="alert" className="font-size100 alert alert-danger">{errors.datum.message}</p>}

        </div>
      </div>
    </div>
    <div className="button-container">
      <button type="submit" className="btn font-size175 submit-form-btn">Weiter</button>
    </div>
  </form>)
}

export function BookingSuccess(props) {
  const email = props.email;

  return <div>
    <h2 className="font-size400 align-left bluetext">Termin bestätigen</h2>
    <div className="font-size150">
      <div className="font-size150">Danke für den Auftrag!</div>
      <div>Eine Zusammenfassung Ihrer Buchung wurde an <span className="bluetext">{email}</span> geschickt. Bitte bestätigen Sie den gebuchten Termin, indem Sie auf den Link in der E-Mail klicken.</div>
    </div>
  </div>
}